/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  dataReport.http
 * @Package :
 * @author:青瞳科技
 * @date:   2022/3/22 16:54
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */
import { axiosAPIUrl, Parameter, exportAxios, assignParams, filterQueryParams } from './index'

export interface TotalDataDTO {
  orderSum: number; // 订单数量
  orderCustomerId: number; // 订货客户数
  orderMoney: number; // 订货金额
  returnOrderSum: number; // 退货数量
  returnOrderCustomerId: number; // 退货客户数
  returnOrderMoney: number; // 退货金额
  differenceMoney: number; // 订货金额-退货金额
  [x: string]: any;
}

export interface DataDTO {
  companyName?: string; // 公司名字
  orderSum?: number; // 订单数量
  orderMoney?: number; // 订货金额
  returnOrderSum?: number; // 退货数量
  returnOrderMoney?: number; // 退货金额
  differenceMoney: number;
  percentage: string;
  levelName: string;
  colorstyle: string;
  name:string // 饼状图返回的展示中文
  random:string // 定义一个唯一不重复的值 用于解决饼状图颜色相同问题
}

/**
 * 退单商品统计合计
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function getReturnOrderStatisticsSum (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjreport/RO/getReturnOrderStatisticsSum',
    method: 'post',
    data: filterQueryParams({...assignParams(), ...params}),
    extraParams: {showLoading: false}
  })
}

/**
 * 退单商品统计详情订单维度
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function getReturnOrderStatisticsByOrder (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjreport/RO/getReturnOrderStatisticsByOrder',
    method: 'post',
    data: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 退单商品统计详情商品维度
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function getReturnOrderStatisticsByGoods (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjreport/RO/getReturnOrderStatisticsByGoods',
    method: 'post',
    data: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 退单商品统计详情客户维度
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function getReturnOrderStatisticsByCustomer (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjreport/RO/getReturnOrderStatisticsByCustomer',
    method: 'post',
    data: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 订单商品统计合计
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function getOrderStatisticsSum (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjreport/OR/getOrderStatisticsSum',
    method: 'post',
    data: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 订单商品统计详情订单维度
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function getOrderStatisticsByOrder (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjreport/OR/getOrderStatisticsByOrder',
    method: 'post',
    data: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 订单商品统计详情商品套餐维度
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function getOrderStatisticsByGoods (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjreport/OR/getOrderStatisticsByGoods',
    method: 'post',
    data: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 订单商品统计详情客户维度
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function getOrderStatisticsByCustomer (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjreport/OR/getOrderStatisticsByCustomer',
    method: 'post',
    data: filterQueryParams({...assignParams(), ...params})
  })
}


/**
 * 退单商品统计导出
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function exportPullReturnOrderStatistics (params: Parameter = {}) {
  return exportAxios<Ajax.Response<any>>({
    url: '/cykjreport/RO/exportPullReturnOrderStatistics',
    method: 'post',
    data: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 订单商品统计导出
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function exportPullOrderStatistics (params: Parameter = {}) {
  return exportAxios<Ajax.Response>({
    url: '/cykjreport/OR/exportPullOrderStatistics',
    method: 'post',
    data: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 订单监控导出
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function exportPullOrderMonitoring (params: Parameter = {}) {
  return exportAxios<Ajax.Response>({
    url: '/cykjreport/OrderMonitoring/exportPullOrderMonitoring',
    method: 'post',
    data: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 客户订货导出
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function exportPullCustomerOrder (params: Parameter = {}) {
  return exportAxios<Ajax.Response>({
    url: '/cykjreport/CustomerOrderStatistics/exportPullCustomerOrder',
    method: 'post',
    data: filterQueryParams({...assignParams(), ...params})
  })
}


/**
 * 订单监控合计
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function getOrderMonitoringTotal (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjreport/OrderMonitoring/getOrderMonitoringTotal',
    method: 'get',
    params: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 订单监控按天
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function getOrderMonitoringByDay (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjreport/OrderMonitoring/getOrderMonitoringByDay',
    method: 'get',
    params: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 订单监控按月
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function getOrderMonitoringByMonth (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjreport/OrderMonitoring/getOrderMonitoringByMonth',
    method: 'get',
    params: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 订单监控按周
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function getOrderMonitoringByWeek (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjreport/OrderMonitoring/getOrderMonitoringByWeek',
    method: 'get',
    params: filterQueryParams({...assignParams(), ...params})
  })
}


/**
 * 客户订货统计扇形
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function getCustomerOrderFan (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjreport/CustomerOrderStatistics/getCustomerOrderFan',
    method: 'post',
    data: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 客户订货统计按客户
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function getCustomerOrderByCId (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjreport/CustomerOrderStatistics/getCustomerOrderByCId',
    method: 'get',
    params: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 客户订货统计按客户级别
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function getCustomerOrderByLever (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjreport/CustomerOrderStatistics/getCustomerOrderByLever',
    method: 'get',
    params: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 商品销售统计合计
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function getGoodsSaleTotal (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjreport/GS/getGoodsSaleTotal',
    method: 'post',
    data: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 按商品统计
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function statisticByGoodsName (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjreport/RegionalByCommodity/statisticByGoodsName',
    method: 'get',
    params: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 按商品统计Top10
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function statisticByGoodsNameTop10 (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjreport/RegionalByCommodity/statisticByGoodsNameTop10',
    method: 'get',
    params: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 按商品分类统计
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function statisticByGoodsCategory (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjreport/RegionalByCommodity/statisticByGoodsCategory',
    method: 'get',
    params: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 按商品分类统计Top10
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function statisticByGoodsCategoryTop10 (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjreport/RegionalByCommodity/statisticByGoodsCategoryTop10',
    method: 'get',
    params: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 按商品品牌统计
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function statisticByGoodsBrand (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjreport/RegionalByCommodity/statisticByGoodsBrand',
    method: 'get',
    params: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 按商品品牌统计Top10
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function statisticByGoodsBrandTop10 (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjreport/RegionalByCommodity/statisticByGoodsBrandTop10',
    method: 'get',
    params: filterQueryParams({...assignParams(), ...params})
  })
}


/**
 * 获取商品分类
 * @param params
 */
export function GetGoodsCategoryList (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjcommodity/shopping/getGoodsCategoryList',
    method: 'post',
    data: {...params, ...assignParams()}
  })
}


/**
 * 地区商品统计导出
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function exportAreaGoods (params: Parameter = {}) {
  return exportAxios<Ajax.Response>({
    url: '/cykjreport/RegionalByCommodity/exportAreaGoods',
    method: 'post',
    data: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 员工拉新统计表
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function pullNewStatistics (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjreport/OP/pullNewStatistics',
    method: 'post',
    data: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 导出员工拉新统计表
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function exportPullNewForm (params: Parameter = {}) {
  return exportAxios<Ajax.Response>({
    url: '/cykjreport/OP/exportPullNewForm',
    method: 'post',
    data: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 员工业绩统计表
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function performanceStatistics (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjreport/ER/performanceStatistics',
    method: 'post',
    data: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 导出员工业绩统计表
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function exportPerformanceForm (params: Parameter = {}) {
  return exportAxios<Ajax.Response>({
    url: '/cykjreport/ER/exportPerformanceForm',
    method: 'post',
    data: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 按区域统计
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function statisticByArea (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjreport/RegionalStatistics/statisticByArea',
    method: 'post',
    data: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 按部门统计
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function statisticByDept (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjreport/RegionalStatistics/statisticByDept',
    method: 'get',
    params: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 地区订单统计导出
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function exportAreaOrder (params: Parameter = {}) {
  return exportAxios<Ajax.Response>({
    url: '/cykjreport/RegionalStatistics/exportAreaOrder',
    method: 'post',
    data: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 按区域统计Top10
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function statisticByAreaTop10 (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjreport/RegionalStatistics/statisticByAreaTop10',
    method: 'post',
    data: filterQueryParams({...assignParams(), ...params})
  })
}

/**
 * 按部门统计Top10
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function statisticByDeptTop10 (params: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjreport/RegionalStatistics/statisticByDeptTop10',
    method: 'post',
    data: filterQueryParams({...assignParams(), ...params})
  })
}
